__turbopack_context__.v({
  "root": "AddressAutocompleteField-module-scss-module__xJVw5G__root",
});
